// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e_zy","scoreRing":"e_Ay","badge":"e_By","badgeImage":"e_Cy","spaced":"e_Dy"};